import { Item } from '../types/common';

const formatRecordToArr = (parsedData: Item | Record<string, string>) =>
  Object.entries(parsedData).map(([key, value]) => {
    return { key, value };
  });

export const parseJsonString = (jsonString: string) => {
  const parsedData = JSON.parse(jsonString) as Item;
  const parsedToArr = formatRecordToArr(parsedData);
  return parsedToArr;
};

const formatArrToRecord = (entries: Item[]) =>
  Object.assign(
    {},
    ...entries.map((item: Item) => {
      return { [item.key]: item.value };
    }),
  );

export const formatArrToJson = (entries: Item[]) => {
  const valueToObj = formatArrToRecord(entries);
  return JSON.stringify(valueToObj);
};
